import styles from "./OrganizationListView.module.scss";
import Table, {
  TableRow,
} from "../../../../../../common/components/molecule/Table/Table";
import StatusBox from "../../../../../../common/components/atom/StatusBox/StatusBox";
import { OrganizationStatus } from "../../../../types/organization.types";
import { themeColorAppJs } from "../../../../../../styles/theme/themeColor";

export interface OrganizationItem {
  id: string;
  name: string;
  city: string;
  country: string;
  status: OrganizationStatus;
  onClick?: () => void;
}

export interface OrganizationListViewProps {
  content?: OrganizationItem[];
  nbFound?: number;
}

/**
 * OrganizationListView
 * @returns
 */
export default function OrganizationListView({
  content,
  nbFound,
}: OrganizationListViewProps) {
  const contentFormated: TableRow[] =
    content?.map((item) => {
      const location = [item.city, item.country].filter(Boolean).join(", ");
      return {
        id: item.id,

        onRowClick: item.onClick,
        data: [item.name, location,
          // () => statusConverterOrg(item.status)
          ],
      };
    }) || [];

  return (
    <div className={styles["global-container"]}>
      <Table
        headerTitle={["Nom", "Ville/Pays"
          ,// "Statut"
          ]}
        bodyData={contentFormated}
        NbFoundViewProps={{
          nbFound: nbFound,
          itemName: {
            single: "organisation trouvée",
            plurial: "organisations trouvées",
          },
        }}
      />
    </div>
  );
}

export const statusConverterOrg = (status: OrganizationStatus) => {
  const size = { width: "80px", height: "20px", font: "0.8rem" };
  switch (status) {
    case "ACTIVATED":
      return (
        <StatusBox size={size} colorType="success">
          Activé
        </StatusBox>
      );
    case "DESACTIVATED":
      return (
        <StatusBox size={size} colorType="error">
          Désactivé
        </StatusBox>
      );
    case "WAITING":
      return (
        <StatusBox size={size} colorType="warning">
          En Attente
        </StatusBox>
      );
    default:
      return (
        <StatusBox
          size={size}
          color={{
            text: themeColorAppJs.gray.dark,
            background: themeColorAppJs.gray.light,
          }}
        >
          Inconnu
        </StatusBox>
      );
  }
};
